// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611051615/js/" + chunkId + "." + {"44":"a1753add","225":"ac0681b7","481":"c908cab0","486":"502c8f95","770":"780b2b75"}[chunkId] + ".0.2998128073071106.chunk.js";
};